module.exports = ".main {\n  padding-top: 60px; }\n\n@media (min-width: 768px) {\n  .page {\n    padding-top: 20px;\n    margin-left: 250px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main